<template>
  <!-- 
    失败页面容器组件
    当用户抽奖未中奖或答题失败时显示
    主要功能：1. 显示失败提示 2. 引导用户关注公众号获取更多抽奖机会 3. 展示公众号二维码
  -->
  <div class="failure-container">
    <!-- 
      背景装饰效果
      使用径向渐变创建柔和的视觉点缀，增强页面美观度
    -->
    <div class="background"></div>
    
    <!-- 
      主内容区域
      包含所有核心UI元素，设置相对定位以正确处理层级关系
    -->
    <div class="content">
      <!-- 
        消息框
        核心内容展示区域，包含失败提示、引导文案和操作按钮
      -->
      <div class="message-box">
        <!-- 
          图标容器
          显示失败状态的圆形图标背景
        -->
        <div class="icon-container">
          <!-- 失败提示文本，采用直接文本而非图标，确保在各种环境中兼容性良好 -->
          <div class="icon">差一点!</div>
           
        </div>
        
        <!-- 页面主标题，使用友好的语气引导用户继续尝试 -->
        <h2 class="title">差一点！明天再试吧</h2>
        
        <!-- 角色插图区域，使用内联SVG作为背景图 -->
        <!-- <div class="character-illustration"></div> -->
        <!-- 二维码显示区域 -->
        <div class="qrcode-container">
          <!-- 
            二维码占位符
            使用SVG格式实现，确保在各种设备上清晰显示
            实际项目中应替换为真实的公众号二维码
          -->
          <div class="qrcode-placeholder">
             <!-- 公众号二维码图片 -->
            <img src="../images/jqr.jpg" alt="公众号二维码" style="width: 200px; height: 200px;"/>
          </div>
          <!-- 扫描提示文本 -->
          <p class="qrcode-tip">关注公众号每天可以参与抽大奖</p>
        </div>
        <!-- 引导文案，明确告知用户关注公众号可获得额外抽奖机会 -->
        <!-- <p class="description">阅读公众号文章有机会获取更多抽奖机会</p> -->
        
        <!-- 
          关注公众号按钮
          点击后显示二维码弹窗
          绑定点击事件修改showQrcode状态
        -->
        <!-- <button class="follow-btn" @click="showQrcode = true">阅读公众号文章</button> -->
        
        <!-- 额外福利提示，增加用户关注公众号的动力 -->
        <!-- <p class="additional-benefit">阅读公众号文章有机会获取更多抽奖机会</p> -->
      </div>
    </div>
    
    <!-- 
      公众号二维码弹窗
      使用条件渲染(v-if)控制显示/隐藏
      点击弹窗外区域(@click.self)可以关闭弹窗
    -->
    <div class="qrcode-modal" v-if="showQrcode" @click.self="showQrcode = false">
      <div class="modal-content">
        <!-- 弹窗关闭按钮，点击后隐藏弹窗 -->
        <div class="close-btn" @click="showQrcode = false">×</div>
        
        <!-- 弹窗标题，指导用户如何操作 -->
        <h3>长按识别二维码</h3>
        
        <!-- 二维码显示区域 -->
        <div class="qrcode-container">
          <!-- 
            二维码占位符
            使用SVG格式实现，确保在各种设备上清晰显示
            实际项目中应替换为真实的公众号二维码
          -->
          <div class="qrcode-placeholder">
             <!-- 公众号二维码图片 -->
            <img src="../images/jqr.jpg" alt="公众号二维码" style="width: 200px; height: 200px;"/>
          </div>
          <!-- 扫描提示文本 -->
          <p class="qrcode-tip">关注公众号每天可以参与抽大奖</p>
        </div>
        
        <!-- 用户操作指引 -->
        <p class="follow-instruction">关注公众号每天可以参与抽大奖</p>
        
        <!-- 
          确认按钮
          点击后调用confirmFollow方法，处理用户确认关注的逻辑
        -->
        <!-- <button class="confirm-btn" @click="confirmFollow">已关注，领取机会</button> -->
      </div>
    </div>
  </div>
</template>

<script>
import globalStore from '../utils/globalStore.js';

export default {
  // 组件名称
  name: 'Failure',
  
  // 组件数据
  data() {
    return {
      showQrcode: false // 控制二维码弹窗的显示状态
    }
  },
  
  // 组件方法
  methods: {
    /**
     * 确认关注公众号方法
     * 模拟用户关注公众号后，重定向到抽奖页面
     * 在实际项目中，应该调用API验证用户是否真的关注了公众号
     */
    confirmFollow() {
      // 关闭二维码弹窗
      this.showQrcode = false;
      // 重定向到抽奖页面，使用全局存储获取URL参数
      this.$router.push({
        path: '/quiz',
        query: globalStore.getUrlParams()
      });
      
      /*
       * 实际项目中的实现建议：
       * 1. 调用后端API验证用户是否已关注公众号
       * 2. 根据验证结果决定是否允许用户再次抽奖
       * 3. 记录用户关注行为和抽奖机会的发放
       */
      // 示例实现代码：
      /*
      async confirmFollow() {
        try {
          const response = await api.checkFollowStatus();
          if (response.success && response.data.isFollowed) {
            this.showQrcode = false;
            this.$router.push('/lottery');
          } else {
            alert('请先关注公众号');
          }
        } catch (error) {
          console.error('验证关注状态失败:', error);
        }
      }
      */
    }
  }
};
</script>

<style scoped>
/* 失败页面容器 */
.failure-container {
  min-height: 100vh; /* 最小高度为视口高度 */
  background-color: #f8f9fa; /* 浅灰色背景 */
  display: flex; /* 弹性布局 */
  justify-content: center; /* 水平居中 */
  align-items: center; /* 垂直居中 */
  padding: 20px; /* 内边距 */
}

/* 背景装饰效果 */
.background {
  position: absolute; /* 绝对定位 */
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: radial-gradient(circle at 20% 30%, rgba(255, 193, 7, 0.1) 0%, transparent 30%),
                    radial-gradient(circle at 80% 70%, rgba(255, 152, 0, 0.1) 0%, transparent 30%);
  /* 两个黄色径向渐变创建装饰效果 */
  z-index: 1; /* 层级较低 */
}

/* 主内容区域 */
.content {
  position: relative; /* 相对定位 */
  z-index: 2; /* 层级较高，在背景之上 */
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}

/* 消息框 */
.message-box {
  background-color: white; /* 白色背景 */
  border-radius: 20px; /* 圆角边框 */
  padding: 40px 20px; /* 内边距 */
  width: 100%;
  max-width: 300px; /* 最大宽度 */
  text-align: center; /* 文本居中 */
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05); /* 轻微阴影 */
}

/* 图标容器 */
.icon-container {
  width: 140px; /* 宽度 */
  height: 60px; /* 高度 */
  background-color: #ffebee; /* 浅红色背景 */
  border-radius: 50%; /* 圆形 */
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto 20px; /* 水平居中 */
}

/* 提示图标 */
.icon {
  font-size: 24px;
  color: #e53935; /* 红色文本 */
  font-weight: bolder;

}

/* 页面标题 */
.title {
  font-size: 20px;
  font-weight: bold;
  color: #333;
  margin-bottom: 20px;
}

/* 角色插图 */
.character-illustration {
  width: 120px;
  height: 120px;
  /* 使用内联SVG作为背景图片 */
  background: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><circle cx="50" cy="35" r="20" fill="#42a5f5"/><path d="M30,55 C30,65 70,65 70,55 L75,80 C75,85 25,85 25,80 Z" fill="#42a5f5"/><circle cx="40" cy="30" r="5" fill="white"/><circle cx="60" cy="30" r="5" fill="white"/><path d="M40,40 Q50,50 60,40" stroke="white" stroke-width="2" fill="transparent"/></svg>') no-repeat center center;
  background-size: contain; /* 背景图片自适应 */
  margin: 0 auto 20px; /* 水平居中 */
}

/* 引导文案 */
.description {
  font-size: 16px;
  color: #333;
  margin-bottom: 25px;
  line-height: 1.5;
}

/* 关注按钮 */
.follow-btn {
  width: 100%; /* 宽度100% */
  padding: 15px 0; /* 垂直内边距 */
  background: linear-gradient(135deg, #ff9800 0%, #ff5722 100%); /* 橙色渐变 */
  color: white;
  border: none; /* 无边框 */
  border-radius: 30px; /* 圆角边框 */
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  box-shadow: 0 5px 15px rgba(255, 152, 0, 0.3); /* 阴影效果 */
  transition: transform 0.3s ease, box-shadow 0.3s ease; /* 过渡动画 */
  margin-bottom: 15px;
}

/* 关注按钮悬停效果 */
.follow-btn:hover {
  transform: translateY(-3px); /* 向上浮动 */
  box-shadow: 0 8px 20px rgba(255, 152, 0, 0.4); /* 增强阴影 */
}

/* 额外福利提示 */
.additional-benefit {
  font-size: 14px;
  color: #ffeb3b; /* 黄色文本 */
  font-weight: bold;
  text-shadow: 0 0 5px rgba(0, 0, 0, 0.1); /* 轻微文本阴影 */
  margin: 0;
}

/* 公众号二维码弹窗样式 */
.qrcode-modal {
  position: fixed; /* 固定定位 */
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7); /* 半透明黑色背景 */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000; /* 最高层级 */
  padding: 20px;
  animation: fadeIn 0.3s ease-out; /* 淡入动画 */
}

/* 淡入动画 */
@keyframes fadeIn {
  from {
    opacity: 0; /* 初始不透明 */
  }
  to {
    opacity: 1; /* 最终完全透明 */
  }
}

/* 弹窗内容 */
.modal-content {
  background-color: white;
  border-radius: 15px;
  padding: 30px;
  width: 100%;
  max-width: 320px;
  text-align: center;
  position: relative;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
  animation: slideUp 0.3s ease-out; /* 上滑动画 */
}

/* 上滑动画 */
@keyframes slideUp {
  from {
    transform: translateY(20px); /* 初始位置向下偏移 */
    opacity: 0;
  }
  to {
    transform: translateY(0); /* 最终位置 */
    opacity: 1;
  }
}

/* 关闭按钮 */
.close-btn {
  position: absolute; /* 绝对定位 */
  top: 10px;
  right: 15px;
  font-size: 24px;
  color: #999;
  cursor: pointer;
  width: 30px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  transition: all 0.2s ease;
}

/* 关闭按钮悬停效果 */
.close-btn:hover {
  background-color: #f0f0f0;
  color: #666;
}

/* 弹窗标题 */
.modal-content h3 {
  font-size: 18px;
  color: #333;
  margin-bottom: 20px;
  margin-top: 10px;
}

/* 二维码容器 */
.qrcode-container {
  margin-bottom: 20px;
}

/* 二维码占位符 */
.qrcode-placeholder {
  width: 200px;
  height: 200px;
  margin: 0 auto 15px;
  border: 1px solid #e0e0e0;
  background-color: #f9f9f9;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* 二维码提示文本 */
.qrcode-tip {
  font-size: 14px;
  color: #666;
  margin-top: 10px;
}

/* 关注指引 */
.follow-instruction {
  font-size: 14px;
  color: #333;
  margin-bottom: 20px;
}

/* 确认按钮 */
.confirm-btn {
  width: 100%;
  padding: 12px;
  background: linear-gradient(135deg, #ff9800 0%, #ff5722 100%); /* 橙色渐变 */
  color: white;
  border: none;
  border-radius: 25px;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(255, 152, 0, 0.3);
}

/* 确认按钮悬停效果 */
.confirm-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(255, 152, 0, 0.4);
}

/* 响应式设计 - 小屏幕设备 */
@media (max-width: 480px) {
  .modal-content {
    padding: 25px 20px; /* 减小内边距 */
  }
  
  .qrcode-placeholder {
    width: 180px; /* 减小宽度 */
    height: 180px; /* 减小高度 */
  }
  
  .qrcode-placeholder svg {
    width: 180px; /* 调整SVG大小 */
    height: 180px; /* 调整SVG大小 */
  }
}
</style>